export const SDK_VERSION = '7.27.0';
